// SOURCE: https://gist.github.com/ilkou/7bf2dbd42a7faf70053b43034fc4b5a4
import {
  CaretSortIcon,
  CheckIcon,
  Cross2Icon as CloseIcon,
} from '@radix-ui/react-icons';
import { Loader2 } from 'lucide-react';
import type {
  ClearIndicatorProps,
  DropdownIndicatorProps,
  GroupBase,
  MenuListProps,
  MenuProps,
  MultiValueRemoveProps,
  OptionProps,
} from 'react-select';
import { components } from 'react-select';

export const DropdownIndicator = (props: DropdownIndicatorProps) => {
  return (
    <components.DropdownIndicator {...props}>
      <CaretSortIcon className={'size-4 opacity-50'} />
    </components.DropdownIndicator>
  );
};

export const ClearIndicator = (props: ClearIndicatorProps) => {
  return (
    <components.ClearIndicator {...props}>
      <CloseIcon className={'size-3.5 opacity-50'} />
    </components.ClearIndicator>
  );
};

export const MultiValueRemove = (props: MultiValueRemoveProps) => {
  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon className={'size-3 opacity-50'} />
    </components.MultiValueRemove>
  );
};

export const Option = (props: OptionProps) => {
  return (
    <components.Option {...props}>
      <div className='flex min-w-0 items-center justify-between gap-2'>
        {/* TODO: Figure out the type */}
        <div className='min-w-0 flex-1 whitespace-normal break-words'>
          {(props.data as { label: string }).label}
        </div>
        {props.isSelected && <CheckIcon className='shrink-0' />}
      </div>
    </components.Option>
  );
};

// Using Menu and MenuList fixes the scrolling behavior
export const Menu = (props: MenuProps) => {
  return <components.Menu {...props}>{props.children}</components.Menu>;
};

type AnyMenuListProps = MenuListProps<unknown, boolean, GroupBase<unknown>>;

function isFetchingMoreMenu(
  selectProps: AnyMenuListProps['selectProps'],
): boolean {
  return (
    (selectProps as { isMenuListFetchingMore?: boolean })
      .isMenuListFetchingMore === true
  );
}

function MenuLoadingRow() {
  return (
    <div className='flex items-center justify-center gap-2 px-2 py-1.5 text-sm text-muted-foreground'>
      <Loader2 className='size-4 shrink-0 animate-spin' aria-hidden />
      <span>Loading more…</span>
    </div>
  );
}

/**
 * Options flow in normal document order. A fixed-height virtual list painted
 * wrapped class names on top of the next row.
 *
 * stopPropagation on wheel so Radix Dialog RemoveScroll does not swallow
 * scroll when the menu is open inside a modal (ENR-3834 / enroll selects).
 */
export const MenuList = (props: AnyMenuListProps) => {
  const showLoadingRow = isFetchingMoreMenu(props.selectProps);
  const { innerProps, ...rest } = props;

  return (
    <components.MenuList
      {...rest}
      innerProps={{
        ...innerProps,
        onWheel: (event) => {
          event.stopPropagation();
          innerProps.onWheel?.(event);
        },
      }}
    >
      {props.children}
      {showLoadingRow ? <MenuLoadingRow /> : null}
    </components.MenuList>
  );
};
